export class ImageConstants {
    public static GrayDeleteApplication = 'assets/Content/images/QNBFB_API_deleteapp_FINAL_BW.png';
    public static GrayAccounts = 'assets/Content/images/QNBFB_API_ikonlar_FINAL_BW_OL-01.png';
    public static GraySignUp = 'assets/Content/images/QNBFB_API_ikonlar_FINAL_BW_OL-02.png';
    public static GrayDeleteAccount = 'assets/Content/images/QNBFB_API_ikonlar_FINAL_BW_OL-03.png';
    public static GrayMoneyTransfers = 'assets/Content/images/QNBFB_API_ikonlar_FINAL_BW_OL-04.png';
    public static GrayCampaigns = 'assets/Content/images/QNBFB_API_ikonlar_FINAL_BW_OL-05.png';
    public static GrayPayment = 'assets/Content/images/QNBFB_API_ikonlar_FINAL_BW_OL-06.png';
    public static GrayCards = 'assets/Content/images/QNBFB_API_ikonlar_FINAL_BW_OL-07.png';
    public static GrayLogin = 'assets/Content/images/QNBFB_API_ikonlar_FINAL_BW_OL-08.png';
    public static GrayCreateNewApp = 'assets/Content/images/QNBFB_API_ikonlar_FINAL_BW_OL-09.png';
    public static GrayInformationServices = 'assets/Content/images/QNBFB_API_ikonlar_FINAL_BW_OL-10.png';
    public static GrayInvestmentProducts = 'assets/Content/images/QNBFB_API_ikonlar_FINAL_BW_OL-11.png';
    public static GrayDeriativeProducts = 'assets/Content/images/QNBFB_API_ikonlar_FINAL_BW_OL-12.png';
    public static GrayPOS = 'assets/Content/images/QNBFB_API_ikonlar_FINAL_BW_OL-13.png';
    public static GrayShowYourMagic = 'assets/Content/images/QNBFB_API_ikonlar_FINAL_BW_OL-14.png';
    public static GrayGear = 'assets/Content/images/QNBFB_API_ikonlar_FINAL_BW_OL-15.png';
    public static GrayCustomerInstructions = 'assets/Content/images/QNBFB_API_ikonlar_FINAL_BW_OL-16.png';
    public static GrayFund = 'assets/Content/images/QNBFB_API_ikonlar_FINAL_BW_OL-17.png';
    public static GrayFarmingCard = 'assets/Content/images/QNBFB_API_ikonlar_FINAL_BW_OL-18.png';
    public static GrayCredits = 'assets/Content/images/QNBFB_API_ikonlar_FINAL_BW_OL-19.png';
    public static GrayGoLive = 'assets/Content/images/QNBFB_API_ikonlar_FINAL_BW_OL-20.png';
    public static GrayResetPassword = 'assets/Content/images/QNBFB_API_ikonlar_FINAL_BW_OL-21.png';
    public static GrayCustomerInformation = 'assets/Content/images/QNBFB_API_ikonlar_FINAL_BW_OL-22.png';
    public static GrayProducts = 'assets/Content/images/QNBFB_API_ikonlar_FINAL_BW_OL-23.png';
    public static GrayTools = 'assets/Content/images/QNBFB_API_ikonlar_FINAL_BW_OL-24.png';

    public static RubyDeleteApplication = 'assets/Content/images/QNBFB_API_deleteapp_FINAL_RUBY_SAND.png';
    public static RubyAccounts = 'assets/Content/images/QNBFB_API_ikonlar_FINAL_RUBY_SAND_OL-01.png';
    public static RubySignUp = 'assets/Content/images/QNBFB_API_ikonlar_FINAL_RUBY_SAND_OL-02.png';
    public static RubyDeleteAccount = 'assets/Content/images/QNBFB_API_ikonlar_FINAL_RUBY_SAND_OL-03.png';
    public static RubyMoneyTransfers = 'assets/Content/images/QNBFB_API_ikonlar_FINAL_RUBY_SAND_OL-04.png';
    public static RubyCampaigns = 'assets/Content/images/QNBFB_API_ikonlar_FINAL_RUBY_SAND_OL-05.png';
    public static RubyPayment = 'assets/Content/images/QNBFB_API_ikonlar_FINAL_RUBY_SAND_OL-06.png';
    public static RubyCards = 'assets/Content/images/QNBFB_API_ikonlar_FINAL_RUBY_SAND_OL-07.png';
    public static RubyLogin = 'assets/Content/images/QNBFB_API_ikonlar_FINAL_RUBY_SAND_OL-08.png';
    public static RubyCreateNewApp = 'assets/Content/images/QNBFB_API_ikonlar_FINAL_RUBY_SAND_OL-09.png';
    public static RubyInformationServices = 'assets/Content/images/QNBFB_API_ikonlar_FINAL_RUBY_SAND_OL-10.png';
    public static RubyInvestmentProducts = 'assets/Content/images/QNBFB_API_ikonlar_FINAL_RUBY_SAND_OL-11.png';
    public static RubyDeriativeProducts = 'assets/Content/images/QNBFB_API_ikonlar_FINAL_RUBY_SAND_OL-12.png';
    public static RubyPOS = 'assets/Content/images/QNBFB_API_ikonlar_FINAL_RUBY_SAND_OL-13.png';
    public static RubyShowYourMagic = 'assets/Content/images/QNBFB_API_ikonlar_FINAL_RUBY_SAND_OL-14.png';
    public static RubyGear = 'assets/Content/images/QNBFB_API_ikonlar_FINAL_RUBY_SAND_OL-15.png';
    public static RubyCustomerInstructions = 'assets/Content/images/QNBFB_API_ikonlar_FINAL_RUBY_SAND_OL-16.png';
    public static RubyFund = 'assets/Content/images/QNBFB_API_ikonlar_FINAL_RUBY_SAND_OL-17.png';
    public static RubyFarmingCard = 'assets/Content/images/QNBFB_API_ikonlar_FINAL_RUBY_SAND_OL-18.png';
    public static RubyCredits = 'assets/Content/images/QNBFB_API_ikonlar_FINAL_RUBY_SAND_OL-19.png';
    public static RubyGoLive = 'assets/Content/images/QNBFB_API_ikonlar_FINAL_RUBY_SAND_OL-20.png';
    public static RubyResetPassword = 'assets/Content/images/QNBFB_API_ikonlar_FINAL_RUBY_SAND_OL-21.png';
    public static RubyCustomerInformation = 'assets/Content/images/QNBFB_API_ikonlar_FINAL_RUBY_SAND_OL-22.png';
    public static RubyProducts = 'assets/Content/images/QNBFB_API_ikonlar_FINAL_RUBY_SAND_OL-23.png';
    public static RubyTools = 'assets/Content/images/QNBFB_API_ikonlar_FINAL_RUBY_SAND_OL-24.png';

    public static OtherAccountGray = 'assets/Content/images/anasayfa_account_icon.png';
    public static OtherAccountRuby = 'assets/Content/images/account_icon.png';
    public static OtherArrow = 'assets/Content/images/delete_account_arrow.png';
    public static OtherBanner = 'assets/Content/images/anasayfa_resim.jpg';
    public static OtherBannerNew = 'assets/Content/images/banner_image.jpg';
    public static OtherCloseButton = 'assets/Content/images/close_button.svg';
    public static OtherCreateNewApp = 'assets/Content/images/create_new_app_icon.png';
    public static OtherCreditCardGray = 'assets/Content/images/anasayfa_credit_card_icon.png';
    public static OtherCreditCardRuby = 'assets/Content/images/credit_card_icon.png';
    public static OtherDeleteAccount = 'assets/Content/images/delete_account_icon.png';
    public static OtherEdit = 'assets/Content/images/edit_icon.png';
    public static OtherFincube = 'assets/Content/images/fincube_logo.png';
    public static OtherFincubeNew = 'assets/Content/images/Fincube-Mavi.png';
    public static OtherForgotPassword = 'assets/Content/images/forgot_pass_image.png';
    public static OtherGoLive = 'assets/Content/images/anasayfa_go_live_icon.png';
    public static OtherHidePassword = 'assets/Content/images/password_goz_kapali.png';
    public static OtherInfo = 'assets/Content/images/info_icon.png';
    public static OtherLineArrow = 'assets/Content/images/line-arrow.svg';
    public static OtherLogin = 'assets/Content/images/login_password_icon.png';
    public static OtherLogo = 'assets/Content/images/qnb_logo_web.png';
    public static OtherLogoScroll = 'assets/Content/images/qnb_logo_web_scroll.png';
    public static OtherMenu = 'assets/Content/images/user_menu_icon.png';
    public static OtherMoneyTransferGray = 'assets/Content/images/anasayfa_money_transfer_icon.png';
    public static OtherNew = 'assets/Content/images/anasayfa_new_icon.png';
    public static OtherPowerOff = 'assets/Content/images/power_off.png';
    public static OtherRefresh = 'assets/Content/images/refresh.png';
    public static OtherRefreshWhite = 'assets/Content/images/refresh_white.png';
    public static OtherShowPassword = 'assets/Content/images/password_goz_acik.png';
    public static OtherShowPasswordOld = 'assets/Content/images/password_gor_ikon.png';
    public static OtherShowYourMagic = 'assets/Content/images/anasayfa_show_your_magic_icon.png';
    public static OtherSignUp = 'assets/Content/images/anasayfa_sign_up_icon.png';
    public static OtherToogleClose = 'assets/Content/images/after_login_kapali.png';
    public static OtherToggleOpen = 'assets/Content/images/after_login_acik.png';
    public static OtherTrashGray = 'assets/Content/images/delete_account_small_icon.png';
    public static OtherTrashWhite = 'assets/Content/images/after_login_cop_sepeti.png';
    public static OtherUser = 'assets/Content/images/user_icon.png';

}

const grayImage = {
    Accounts:  ImageConstants.GrayAccounts,
    Campaigns:  ImageConstants.GrayCampaigns,
    Cards:  ImageConstants.GrayCards,
    CreateNewApp:  ImageConstants.GrayCreateNewApp,
    Credits:  ImageConstants.GrayCredits,
    CustomerInformation:  ImageConstants.GrayCustomerInformation,
    CustomerInstructions:  ImageConstants.GrayCustomerInstructions,
    DeleteAccount:  ImageConstants.GrayDeleteAccount,
    DeleteApplication:  ImageConstants.GrayDeleteApplication,
    DeriativeProducts:  ImageConstants.GrayDeriativeProducts,
    FarmingCard:  ImageConstants.GrayFarmingCard,
    Fund:  ImageConstants.GrayFund,
    Gear:  ImageConstants.GrayGear,
    GoLive:  ImageConstants.GrayGoLive,
    InformationServices:  ImageConstants.GrayInformationServices,
    InvestmentProducts:  ImageConstants.GrayInvestmentProducts,
    Login:  ImageConstants.GrayLogin,
    MoneyTransfers:  ImageConstants.GrayMoneyTransfers,
    POS:  ImageConstants.GrayPOS,
    Payment:  ImageConstants.GrayPayment,
    Products:  ImageConstants.GrayProducts,
    ResetPassword:  ImageConstants.GrayResetPassword,
    ShowYourMagic:  ImageConstants.GrayShowYourMagic,
    SignUp:  ImageConstants.GraySignUp,
    Tools:  ImageConstants.GrayTools,
};
const rubyImage = {
    Accounts:  ImageConstants.RubyAccounts,
    Campaigns:  ImageConstants.RubyCampaigns,
    Cards:  ImageConstants.RubyCards,
    CreateNewApp:  ImageConstants.RubyCreateNewApp,
    Credits:  ImageConstants.RubyCredits,
    CustomerInformation:  ImageConstants.RubyCustomerInformation,
    CustomerInstructions:  ImageConstants.RubyCustomerInstructions,
    DeleteAccount:  ImageConstants.RubyDeleteAccount,
    DeleteApplication:  ImageConstants.RubyDeleteApplication,
    DeriativeProducts:  ImageConstants.RubyDeriativeProducts,
    FarmingCard:  ImageConstants.RubyFarmingCard,
    Fund:  ImageConstants.RubyFund,
    Gear:  ImageConstants.RubyGear,
    GoLive:  ImageConstants.RubyGoLive,
    InformationServices:  ImageConstants.RubyInformationServices,
    InvestmentProducts:  ImageConstants.RubyInvestmentProducts,
    Login:  ImageConstants.RubyLogin,
    MoneyTransfers:  ImageConstants.RubyMoneyTransfers,
    POS:  ImageConstants.RubyPOS,
    Payment:  ImageConstants.RubyPayment,
    Products:  ImageConstants.RubyProducts,
    ResetPassword:  ImageConstants.RubyResetPassword,
    ShowYourMagic:  ImageConstants.RubyShowYourMagic,
    SignUp:  ImageConstants.RubySignUp,
    Tools:  ImageConstants.RubyTools,
};
const otherImage = {
    AccountGray:  ImageConstants.OtherAccountGray,
    AccountRuby:  ImageConstants.OtherAccountRuby,
    Arrow:  ImageConstants.OtherArrow,
    Banner:  ImageConstants.OtherBanner,
    BannerNew:  ImageConstants.OtherBannerNew,
    CloseButton:  ImageConstants.OtherCloseButton,
    CreateNewApp:  ImageConstants.OtherCreateNewApp,
    CreditCardGray:  ImageConstants.OtherCreditCardGray,
    CreditCardRuby:  ImageConstants.OtherCreditCardRuby,
    DeleteAccount:  ImageConstants.OtherDeleteAccount,
    Edit:  ImageConstants.OtherEdit,
    Fincube:  ImageConstants.OtherFincube,
    FincubeNew:  ImageConstants.OtherFincubeNew,
    ForgotPassword:  ImageConstants.OtherForgotPassword,
    GoLive:  ImageConstants.OtherGoLive,
    HidePassword:  ImageConstants.OtherHidePassword,
    Info:  ImageConstants.OtherInfo,
    LineArrow:  ImageConstants.OtherLineArrow,
    Login:  ImageConstants.OtherLogin,
    Logo:  ImageConstants.OtherLogo,
    LogoScroll:  ImageConstants.OtherLogoScroll,
    Menu:  ImageConstants.OtherMenu,
    MoneyTransferGray:  ImageConstants.OtherMoneyTransferGray,
    New:  ImageConstants.OtherNew,
    PowerOff:  ImageConstants.OtherPowerOff,
    Refresh:  ImageConstants.OtherRefresh,
    RefreshWhite:  ImageConstants.OtherRefreshWhite,
    ShowPassword:  ImageConstants.OtherShowPassword,
    ShowPasswordOld:  ImageConstants.OtherShowPasswordOld,
    ShowYourMagic:  ImageConstants.OtherShowYourMagic,
    SignUp:  ImageConstants.OtherSignUp,
    ToogleClose:  ImageConstants.OtherToogleClose,
    ToggleOpen:  ImageConstants.OtherToggleOpen,
    TrashGray:  ImageConstants.OtherTrashGray,
    TrashWhite:  ImageConstants.OtherTrashWhite,
    User:  ImageConstants.OtherUser
};

export const Images = {
    Gray: grayImage,
    Ruby: rubyImage,
    Other: otherImage
};
